export default __webpack_public_path__ + "static/media/backArrowGrey.71fe1cdb.svg";